import { logger } from "@justhome/common";
import { Component, ReactNode } from "react";
import ErrorPage from "../../pages/_error";
interface Props {
  children: ReactNode;
}
interface State {
  hasError: boolean;
}
class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false
  };
  public static getDerivedStateFromError(): State {
    // Update state so the next render will show the fallback UI.
    return {
      hasError: true
    };
  }
  public componentDidCatch(error: Error) {
    logger.error("Unhandled error", error);
  }
  public render() {
    if (this.state.hasError) {
      return <ErrorPage />;
    }
    return this.props.children;
  }
}
export default ErrorBoundary;